import Row from '@components/Row';
import colors from '@constants/colors';
import styled from '@emotion/styled';

interface Props {
    /** 지금까지 입력한 자릿수 */
    length: number;
    maxLength?: number;
}

/** PIN 입력 자릿수를 점으로 보여준다 */
function PinDots({ length, maxLength = 6 }: Props) {
    return (
        <Row spacing={3}>
            {Array.from({ length: maxLength }).map((_, idx) => (
                <Dot key={idx.toString()}
                    active={idx < length} />
            ))}
        </Row>
    );
}

const Dot = styled('div', {
    shouldForwardProp: (prop) => prop !== 'active',
})<{
    active: boolean;
}>`
    width: 18px;
    height: 18px;
    border-radius: 100px;
    background-color: ${({ active }) => (active ? colors.primary : colors.gray2)};
`;

export default PinDots;
